import React from 'react';
import { Modal } from '@gerdau/hefesto';
import { ISaveUser, IUserState } from '../../store/ducks/user/types';
import { useDispatch } from 'react-redux';
import { saveUser } from '../../store/ducks/user/actions';

interface GerdauProModalProps {
  onCloseModal: () => void;
  user: IUserState;
}

const GerdauProVideoModal: React.FC<GerdauProModalProps> = ({
  onCloseModal,
  user
}) => {
  const dispatch = useDispatch();

  const updateUser = (gerdauProModal: boolean) => {
    const saveUserProps: ISaveUser = {
      user,
      gerdauProModal
    };
    dispatch(saveUser(saveUserProps));
  };

  const onDoNotShowClick = () => {
    updateUser(false);
    onCloseModal();
  };

  return (
    <Modal
      buttons={{
        left: {
          children: 'Não Exibir Novamente ',
          name: 'cancel-upload-confirm',
          onClick: onDoNotShowClick,
          type: 'button',
          variant: 'secondary'
        },
        right: {
          children: 'Fechar',
          name: 'continue-upload',
          onClick: onCloseModal,
          type: 'button',
          variant: 'primary'
        }
      }}
      modalSize="lg"
      title="Conheça o Gerdau Pro"
    >
      <div className="video-responsive">
        <span>
          Agora você já pode contar com novo aplicativo da Gerdau, o Gerdau Pro,
          para facilitar seu processo de recebimento de vergalhão cortado e
          dobrado. <br /> Inovador, exclusivo e fácil de usar, reduz o tempo de
          conferência, trazendo agilidade e produtividade 👷🏻‍♀️🏗 Disponível para
          Android e IOS.
          <br />
        </span>
        <iframe
          id="ytplayer"
          width="898"
          height="480"
          src="https://www.youtube.com/embed/IIGiMpcWwUs?autoplay=1"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
          allowFullScreen
          title="Tem novidade por aqui: lançamos de forma pioneira o aplicativo Gerdau PRO!"
        />
      </div>
    </Modal>
  );
};

export default GerdauProVideoModal;
